import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../../../../context/installation';
import { SeasonPricesQuery, SeasonPricesQueryVariables } from '../../../../../../../data-access/gql-types/graphql';
import { SEASON_PRICES } from '../../../../../../../data-access/queries/meter';
import { useGetTariffs } from '../../../../../hooks/tariffs/use-get-tariffs';
import { useDashboardContext } from '../../../context/dashboard-context';
import { DashboardPrice } from '../../../types/types';
import { getColorByHour } from '../../../utils/prices';
import { DashboardTariffHours } from '../tariff-hours';

export const GnHours: React.FC = () => {
  const { allTariffs } = useGetTariffs();
  const { tariffOperator, tariff } = useDashboardContext();
  const { skipLavvaFetch, selectedInstallationId } = useInstallationContext();
  const { data, loading } = useQuery<SeasonPricesQuery, SeasonPricesQueryVariables>(SEASON_PRICES, {
    variables: { installationId: selectedInstallationId },
    skip: skipLavvaFetch,
  });

  const gnPrices: DashboardPrice[] = useMemo(() => {
    if (!tariffOperator || !tariff) return [];

    const tariffData = allTariffs
      ?.find((x) => x.operator.toLowerCase() === tariffOperator.toLowerCase())
      ?.tariffs.find((x) => x.name.toLowerCase() === tariff);

    if (!tariffData?.hoursRanges?.length) return [];

    let holidays: string[] = [];
    if (data?.seasonPrices) holidays = [...data.seasonPrices.staticHolidays, ...data.seasonPrices.movableHolidays];

    const currentHour = new Date().getHours();
    const prices = Array.from({ length: 24 }, (_, i) => i);

    const dashboardPrices: DashboardPrice[] = [...prices]
      .sort((a, b) => {
        const ah = (a - currentHour + 24) % 24;
        const bh = (b - currentHour + 24) % 24;
        return ah - bh;
      })
      .map((x) => ({
        startingHour: x,
        color: getColorByHour(tariffData, x, holidays),
      }));

    return dashboardPrices;
  }, [allTariffs, tariff, tariffOperator, data?.seasonPrices]);

  return <DashboardTariffHours prices={gnPrices} loading={loading} />;
};
